// src/pages/Game/GameResult.jsx
import React from "react";
import { Link, useLocation } from "react-router-dom";

export default function GameResult() {
  const { state } = useLocation();

  if (!state) {
    return (
      <div className="p-10 text-center">
        <h2 className="text-2xl font-bold text-red-600">
          ⚠ No Result Found
        </h2>
        <Link to="/game" className="text-blue-600 underline block mt-3">
          Go to Game
        </Link>
      </div>
    );
  }

  const {
    points,
    totalCorrect,
    bestStreak,
    fastestAnswerMs,
    xp,
    rank,
    badges,
    testTitle,
  } = state;

  return (
    <div className="p-6 max-w-3xl mx-auto">
      <div className="bg-white shadow-xl rounded-2xl p-8 text-center">
        <h1 className="text-3xl font-bold mb-4">
          🎉 Game Finished — {testTitle}
        </h1>

        {/* STATS */}
        <div className="grid grid-cols-1 sm:grid-cols-2 gap-4 my-6">
          <div className="p-4 bg-blue-50 rounded-xl shadow">
            <h3 className="text-xl font-semibold">🏆 Points</h3>
            <p className="text-2xl font-bold">{points}</p>
          </div>

          <div className="p-4 bg-green-50 rounded-xl shadow">
            <h3 className="text-xl font-semibold">✔ Correct</h3>
            <p className="text-2xl font-bold">{totalCorrect}</p>
          </div>

          <div className="p-4 bg-yellow-50 rounded-xl shadow">
            <h3 className="text-xl font-semibold">🔥 Best Streak</h3>
            <p className="text-2xl font-bold">{bestStreak}</p>
          </div>

          <div className="p-4 bg-purple-50 rounded-xl shadow">
            <h3 className="text-xl font-semibold">⚡ Fastest Answer</h3>
            <p className="text-2xl font-bold">
              {fastestAnswerMs
                ? `${(fastestAnswerMs / 1000).toFixed(2)}s`
                : "—"}
            </p>
          </div>
        </div>

        {/* XP + Rank */}
        <div className="p-4 bg-indigo-50 rounded-xl shadow mb-4">
          <h3 className="text-xl font-semibold">⭐ New Rank</h3>
          <p className="text-2xl font-bold text-indigo-700">{rank}</p>
          <p className="mt-1 text-gray-700">Total XP: {xp}</p>
        </div>

        {/* BADGES */}
        <div className="mt-5">
          <h3 className="text-xl font-semibold mb-2">🏅 Badges Earned</h3>

          {(!badges || badges.length === 0) && (
            <p className="text-gray-500">No badges unlocked this time.</p>
          )}

          {badges?.length > 0 && (
            <div className="flex gap-2 justify-center flex-wrap">
              {badges.map((b, i) => (
                <span
                  key={i}
                  className="px-3 py-1 bg-amber-100 text-amber-800 rounded-full text-sm shadow"
                >
                  {b}
                </span>
              ))}
            </div>
          )}
        </div>

        {/* BUTTONS */}
        <div className="mt-8 flex justify-center gap-4">
          <Link
            to="/game/play-again"
            state={{ replay: true }}
            className="px-4 py-2 bg-green-600 text-white rounded-xl hover:bg-green-700 shadow"
          >
            Play Again
          </Link>

          <Link
            to="/game"
            className="px-4 py-2 bg-gray-800 text-white rounded-xl hover:bg-gray-900 shadow"
          >
            Select Another Test
          </Link>
        </div>
      </div>
    </div>
  );
}
